





















































import {Component, PropSync} from "vue-property-decorator";
import {Action, Getter} from "vuex-class";
import BaseFilter from "@/components/Filter/BaseFilter";
import {BalanceFilter} from "@/store/finance/types";
import {DatePickerWings, FastDateDetailWings, SelectWings} from "wings-ui-components";
import {beginningOfCurrentDay, currentDateEnd, dateFilter} from "@/utils/date-util";
import axios from "axios";
import {ActionLog} from "@/store/auth/types";

@Component({components: {SelectWings, DatePickerWings, FastDateDetailWings}, filters: {dateFilter}})
export default class BalancesFilter extends BaseFilter<BalanceFilter>{
  @PropSync('show') is_show!: boolean;
  @Action("getPartners") actionGetPartners: any;
  @Action("getBalances") actionGetBalances: any;
  @Action("actionLog") actionLog: any;

  defaultFilter(): BalanceFilter {
    return {
      date_from: beginningOfCurrentDay(),
      date_to: currentDateEnd(),
      partner: undefined,
      source: undefined
    }
  }

  params = {prepaid: true}
  partnersList: any = []

  async getPartnersList(filter: any) {
    const items = await this.actionGetPartners({...this.params, ...filter});
    this.partnersList = (filter?.page_number > 1) ? this.partnersList.concat(items) : items
  }

  async created() {
    this.filtered();
    if (this.filter.partner) this.partnersList = await this.actionGetPartners({name: this.filter.partner});
  }

 async onFilteredAction() {
    if (this.filter.date_from && this.filter.date_to){
      this.logObject = {
        action_page: this.$route.meta.msgKey,
        action: "Viewing",
        action_status: "success",
        object_type: "Balance history",
        addititional_info: this.filter
      };
      await this.actionGetBalances(this.filter);
      await this.actionLog(this.logObject);
      await this.$emit('check-filter-event', true);
    }else {
      await this.actionLog({...this.logObject, action_status: "failed"});
      this.$emit('check-filter-event', false);
    }
  }
}
